import {
  ODataHeader,
  ODataString,
  ODataDateTime,
  // ODataDate,
  ODataDecimal,
  ODataEnum,
  ODataInteger,
} from "pbas-vue-components";

import { i18n } from "@/plugins/i18n";
import store from "@/store";
import { translate } from "../trans";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

function getHeaders(enums, link) {
  const headers = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "views.planbalance.cheque_number",
      type: new ODataInteger("PaymentNumber"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("PayeeFirstName"),
      visible: false,
      allowVisibilityChange: false,
      searchable: true,
    }),
    new ODataHeader({
      title: "components.chequerequisitionform.payee",
      type: new ODataString("PayeeLastName", {
        getString: (item) => {
          let fn = "";
          let ln = "";
          if (
            item.PayeeFirstName !== null &&
            item.PayeeFirstName !== undefined
          ) {
            fn = item.PayeeFirstName;
          }
          if (item.PayeeLastName !== null && item.PayeeLastName !== undefined) {
            ln = item.PayeeLastName;
          }
          return `${fn} ${ln}`;
        },
      }),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.claims_payments.Payee",
      type: new ODataEnum("Payee", {
        getString: (item) => {
          return i18n.t("enums." + item.Payee);
        },
        dropdownItems: enums.Payee,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "components.expenses_table.paid_amount",
      type: new ODataDecimal("TotalAmount", {
        getString: (item) => {
          const value = item.TotalAmount;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "components.claims_history.header.submission_id",
      type: new ODataString("ClaimSubmission/Identifier", {
        getHtml: (item) => {
          if (link) {
            return `<a id="${item.ClaimSubmission.Identifier}">${
              item.ClaimSubmission.Identifier
            }</a>`;
          } else {
            return item.ClaimSubmission.Identifier;
          }
        },
      }),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "ClaimSubmission/Id",
      type: new ODataString("ClaimSubmission/Id"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "ClaimSubmission/Id",
      type: new ODataString("ClaimSubmission/MemberId"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "headers.claims_payments.CancelledAt",
      type: new ODataDateTime("CancelledAt"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
  return headers;
}

export default getHeaders;
